'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _sizes = require('../../constants/sizes');

var _input = require('../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _dropDown = require('../lists/dropDown');

var _dropDown2 = _interopRequireDefault(_dropDown);

var _postalCode = require('../postalCode');

var _postalCode2 = _interopRequireDefault(_postalCode);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManualAddress = function (_React$Component) {
    _inherits(ManualAddress, _React$Component);

    function ManualAddress() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ManualAddress);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManualAddress.__proto__ || Object.getPrototypeOf(ManualAddress)).call.apply(_ref, [this].concat(args))), _this), _this.updateChildRef = function (childRef, code) {
            var ref = childRef;

            if (code && ref) {
                ref = ref.filter(function (x) {
                    return x.elements[0].value === code;
                });
            }

            return ref;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ManualAddress, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.address || this.props.address.country === null && this.props.address.countryCode === null || this.props.address.country === '' && this.props.address.countryCode === '') {
                this.props.changeEvent('code', 'MANUAL');
                this.props.changeEvent('countryCode', 'CAN');
                this.props.changeEvent('country', 'Canada');
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.getFormattedAddress(this.props.address) !== this.props.getFormattedAddress(prevProps.address)) {
                this.props.geoCode();
            }
        }

        // Function to update child reference as per parent value

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var address = this.props.address || {};
            return _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    { nogutterbottom: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 3,
                            nogutterleft: true
                        },
                        _react2.default.createElement(_input2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.streetNumber' }),
                            value: address.streetNumber,
                            changeEvent: function changeEvent(value) {
                                return _this2.props.changeEvent('streetNumber', value);
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 9,
                            md: 6,
                            nogutterright: this.context.screen.isMobile
                        },
                        _react2.default.createElement(_input2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.street' }),
                            value: address.street,
                            changeEvent: function changeEvent(value) {
                                return _this2.props.changeEvent('street', value);
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 3,
                            nogutterleft: this.context.screen.isMobile,
                            nogutterright: !this.context.screen.isMobile
                        },
                        _react2.default.createElement(_input2.default, { top: this.context.screen.isMobile && _sizes.Sizes.xs,
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.apartmentSuite' }),
                            value: address.apartmentSuite,
                            changeEvent: function changeEvent(value) {
                                return _this2.props.changeEvent('apartmentSuite', value);
                            },
                            optional: true
                        })
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    { nogutterbottom: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 6,
                            nogutterleft: !this.context.screen.isMobile,
                            nogutter: this.context.screen.isMobile
                        },
                        _react2.default.createElement(_input2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.city' }),
                            value: address.city,
                            changeEvent: function changeEvent(value) {
                                return _this2.props.changeEvent('city', value);
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 6,
                            nogutterright: !this.context.screen.isMobile,
                            nogutter: this.context.screen.isMobile
                        },
                        (!this.props.allowInternational || address.countryCode === 'CAN') && _react2.default.createElement(_dropDown2.default, {
                            top: this.context.screen.isMobile && _sizes.Sizes.xs,
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.province' }),
                            referencesEvent: function referencesEvent() {
                                return _this2.props.referencesEvent('StateProvince');
                            },
                            references: this.props.references['StateProvince'] && this.updateChildRef(this.props.references['StateProvince'], address.countryCode),
                            value: address.stateCode && { code: address.stateCode },
                            changeEvent: function changeEvent(value) {
                                address = _extends({}, address, { state: value.value, stateCode: value.code });
                                _this2.props.changeEvent('address', address);
                            }
                        }),
                        this.props.allowInternational && address.countryCode !== 'CAN' && _react2.default.createElement(_dropDown2.default, {
                            top: this.context.screen.isMobile && _sizes.Sizes.xs,
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.state' }),
                            referencesEvent: function referencesEvent() {
                                return _this2.props.referencesEvent('StateProvince');
                            },
                            references: this.props.references['StateProvince'] && this.updateChildRef(this.props.references['StateProvince'], address.countryCode),
                            value: address.stateCode && { code: address.stateCode },
                            changeEvent: function changeEvent(value) {
                                address = _extends({}, address, { state: value.value, stateCode: value.code });
                                _this2.props.changeEvent('address', address);
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    { nogutterbottom: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 6,
                            nogutterleft: true,
                            nogutterright: this.context.screen.isMobile
                        },
                        (!this.props.allowInternational || address.countryCode === 'CAN') && _react2.default.createElement(_postalCode2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.postalCode' }),
                            value: address.postalCode,
                            changeEvent: this.props.changeEvent
                        }),
                        this.props.allowInternational && address.countryCode !== 'CAN' && _react2.default.createElement(_input2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.postalZip' }),
                            value: address.postalCode,
                            changeEvent: function changeEvent(value) {
                                return _this2.props.changeEvent('postalCode', value);
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 6,
                            nogutterleft: this.context.screen.isMobile,
                            nogutterright: true
                        },
                        _react2.default.createElement(_input2.default, { label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ManualAddress.country' }),
                            value: address.country,
                            top: this.context.screen.isMobile && _sizes.Sizes.xs,
                            disabled: address.country
                        })
                    )
                )
            );
        }
    }]);

    return ManualAddress;
}(_react2.default.Component);

ManualAddress.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = ManualAddress;